import { shareButtonTemplatesEnum } from "../enums/shareButtonTemplatesEnum";

export const getShareButtonTemplate = (templateName) => (pageTitle, pageUrl, body) => {
  if (templateName in shareButtonTemplatesEnum) {
    return shareButtonTemplatesEnum[templateName](pageTitle, pageUrl, body);
  }

  return () => null;
};
